import { ColumnDef } from '@tanstack/react-table';
import { WidgetViewMode, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { UseBaseTable } from 'hooks/useBaseTable';

import { TableV8 } from 'components/common/Tables/TableV8/tableV8';

import { TreeRow } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/PivotBoard.logic';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/components/GroupByTable/GroupedByTable.module.scss';

interface Props {
    TableData: TreeRow[];
    table: UseBaseTable['table'];
    isLoading: boolean;
    tableColumns: ColumnDef<TreeRow>[];
    widgetViewMode: WidgetViewMode;
}

export const GroupedByTable = ({ table, TableData, isLoading, tableColumns, widgetViewMode }: Props) => {
    return (
        <TableV8<TreeRow>
            data={TableData}
            columns={tableColumns}
            isLoading={isLoading}
            sorting={table.sorting}
            setSorting={table.setSorting}
            manualSorting={false}
            columnVisibility={table.columnVisibility}
            ref={table.tableRef}
            tableClassName={
                WidgetViewModeUtils.isReportAddOrEditWidget(widgetViewMode) ? '' : classes.pivotBoardInnerTable
            }
        />
    );
};
